import Navbar from './Navbar';
import ChatSys from './ChatSys';

const Chat = () => (
    <div className="inner-page">
        <Navbar />
        <main>
            <header className="inner-page-hero project-page-hero chat-page-hero">
                <div className="container">
                    <h1>Real-Time Chat</h1>
                    <p className="inner-page-intro">
                        A live chat system to communicate with other users (browsers) in real time. Sign in with Google, and send a message for it to instantly appear for everyone else. Scroll down to check it out!
                    </p>
                </div>
            </header>
            <div className="container project-notes project-notes-top">
                <details>
                    <summary>How I built it</summary>
                    <p>
                        I used React to listen for the Firebase authentication state. Once signed in, the app subscribes to the newest 100 Firestore messages and displays them properly (formatting and displaying in order). Sending a message writes a document with the sender and a server-generated timestamp to the Firestore collection, which triggers a live update for all other users. I also added a sign-out button and a loading state while the authentication status is being checked.
                    </p>
                </details>
                <details>
                    <summary>Challenges</summary>
                    <p>
                        This one was fun, as I got to learn a little bit about Firebase. I ran into an issue where the Google sign-in popup would not change React's state, so I had to use a listener for the authentication state instead of relying on the promise returned by the sign-in function. I also had to make sure that the Firestore subscription was cleaned up when the component unmounted.
                    </p>
                </details>
                <details>
                    <summary>What I’d improve next</summary>
                    <p>
                        I'd love to add other sign-in methods (like Meta or GitHub), and possibly a way to reply to other messages. I could also add a way to see who is currently online, or maybe a little number that shows how many people are currently online.
                    </p>
                </details>
            </div>
            <ChatSys />
        </main>
    </div>
);

export default Chat;
